<template>
  <el-select
    :value="value"
    :placeholder="placeholder"
    clearable
    filterable
    :filter-method="filterMethod"
    :reserve-keyword="reservekeyword"
    :multiple="multiple"
    :collapse-tags="collapseTags"
    popper-class="customer-select-dropdown"
    v-bind="$attrs"
    @change="onChange"
    v-on="$listeners"
  >
    <div class="customer-select-header">
      <div class="customer-select-column">Account Code</div>
      <div class="customer-select-column">CID</div>
      <div class="customer-select-column">GID</div>
    </div>
    <el-option
      v-for="item in filteredOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value"
      class="customer-select-option"
    >
      <div class="customer-select-row">
        <div class="customer-select-column" :title="item.label">{{ item.label }}</div>
        <div class="customer-select-column" :title="item.customerId">{{ item.customerId }}</div>
        <div class="customer-select-column" :title="item.groupId">{{ item.groupId }}</div>
      </div>
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: 'CustomerSelect',
  props: {
    value: {
      type: [String, Number, Boolean, Array],
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: 'Please select'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    collapseTags: {
      type: Boolean,
      default: false
    },
    reservekeyword: {
      type: Boolean,
      default: false
    },
    maxDisplay: {
      type: Number,
      default: 50
    }
  },
  data() {
    return {
      filterText: '',
      filteredOptions: []
    }
  },
  watch: {
    options: {
      handler(newVal) {
        this.updateFilteredOptions()
      },
      immediate: true
    }
  },
  methods: {
    filterMethod(query) {
      this.filterText = query
      this.updateFilteredOptions()
    },
    updateFilteredOptions() {
      let result = this.options

      // 如果有搜索文本,进行过滤
      if (this.filterText) {
        const query = this.filterText.toLowerCase()
        result = this.options.filter(item => {
          return (
            (item.label && item.label.toLowerCase().includes(query)) ||
            (item.customerId && item.customerId.toLowerCase().includes(query)) ||
            (item.groupId && item.groupId.toLowerCase().includes(query))
          )
        })
      }

      // 无论是否搜索，都限制最多显示的条数
      this.filteredOptions = result.slice(0, this.maxDisplay)
    },
    onChange(val) {
      this.$emit('input', val)
      const obj = this.options.find(item => item.value === val)
      if (obj) {
        this.$emit('changeRow', obj)
      }
    }
  }
}

</script>

<style lang='scss' scoped>
.el-select {
  width: 100%;
}
</style>

<style lang="scss">
.customer-select-dropdown {
  width: 560px !important;

  .el-select-dropdown__list {
    padding-top: 0;
  }

  .popper__arrow::after {
    border-bottom-color: #dddddd !important;
  }

  .customer-select-header {
    display: flex;
    background-color: #dddddd;
    color: #28123b;
    border-bottom: 1px solid #e4e7ed;
    font-weight: bold;
    font-size: 13px;
    position: sticky;
    top: 0;
    z-index: 1;

    .customer-select-column {
      border-right: 1px solid #bbb;
      padding: 8px;

      &:last-child {
        border-right: none;
      }
    }
  }

  .customer-select-option {
    padding: 0 !important;
    height: auto !important;
    line-height: normal !important;

    &.hover,
    &:hover {
      background-color: #f5f7fa;
    }

    &.selected {
      font-weight: normal;
    }
  }

  .customer-select-row {
    display: flex;
    width: 100%;
  }

  .customer-select-column {
    min-width: 0;
    padding: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-right: 1px solid #e2e2e2;

    &:first-child {
      flex: 6;
    }

    &:nth-child(2),
    &:nth-child(3) {
      flex: 2;
    }

    &:last-child {
      border-right: none;
    }
  }
}
</style>
